import { faFileExcel, faList, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridDetailRow } from "@progress/kendo-react-grid";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import * as React from "react";
import { history } from "../../../../HelperMethods";
import Auth from "../../../Auth";
import { AppPermissions } from "../../../Shared/Constants/AppPermissions";
import { CREATE_REPORT_PERMISSION, EDIT_REPORT_PERMISSION_PARAM } from "../../../Shared/ApiUrls";
import { ROWACTIONS } from "../../../Shared/AppConstants";

export class DetailColumnCell extends React.Component<{ dataItem: any; expandChange: any; rowType: any }> {
    render() {
        let dataItem = this.props.dataItem;
        if (this.props.rowType == "groupHeader") {
            return <td colSpan={0} className="d-none"></td>;
        }
        return (
            <td contextMenu="View More" style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                    icon={faList}
                    style={{ marginLeft: "0px!important", marginTop: "0", fontSize: "16px" }}
                    className={"active-icon-blue left-margin cursorPointer"}
                    onClick={() => this.props.expandChange(dataItem)}
                />
            </td>
        );
    }
}

export const ExportExcel = (data?) => {
    return (

        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => data()}>
            <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Export to Excel{" "}
        </div>
    )
};

export const AddNewActionReason = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick={() => history.push(CREATE_REPORT_PERMISSION)}>

            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add New Report Permission{" "}
        </div>
    );
};

export const MenuRender = (props) => {
    return <span className="k-icon k-i-more-horizontal" style={{ color: "white" }}></span>;
};

export const CustomMenu = (excelData) => {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
                {Auth.hasPermissionV2(AppPermissions.REPORT_PERMISSION_CREATE) &&
                    <MenuItem render={() => AddNewActionReason()} />}
                <MenuItem render={() => ExportExcel(excelData)} />
            </MenuItem>
        </Menu>
    );

};

export class ViewMoreComponent extends GridDetailRow {
    render() {
        const dataItem = this.props.dataItem;
        return <DialogBox {...dataItem} />;
    }
}

export function DefaultActions(props) {
    const { dataItem } = props;
    var defaultActions = [
        {
            action: ROWACTIONS.EDIT,
            permCode: AppPermissions.REPORT_PERMISSION_UPDATE,
            nextState: "",
            icon: "faPencilAlt",
            linkUrl: `${EDIT_REPORT_PERMISSION_PARAM}${dataItem.reportPermissionId}`,
        },
        {
            action: ROWACTIONS.REMOVE,
            permCode: AppPermissions.REPORT_PERMISSION_DELETE,
            nextState: "",
            icon: "faTrashAlt",
        },
        {
            action: `${dataItem.status == "Active" ? ROWACTIONS.DEACTIVATE : ROWACTIONS.ACTIVATE}`,
            permCode: AppPermissions.REPORT_PERMISSION_DELETE,
            nextState: "",
            icon: `${dataItem.status == "Active" ? "faTimesCircle" : "faCheckCircle"}`,
        },
        {
            action: ROWACTIONS.VIEWEVENTS,
            permCode: AppPermissions.EVENT_VIEW,
            nextState: "",
            icon: "faEye",
            linkUrl: `/admin/eventslogs/manage/${dataItem.reportPermissionId}`,
        },

    ];
    return defaultActions;
}

export const DialogBox = (props) => {
    return (
        <div className="row">
            <div className="col-12 col-lg-11 text-dark">
                <div className="row ml-0 mr-0 mt-1">
                    <div className="col-12 pl-0 text-right">
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Description :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {props.description}</label>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-6">
                                <label className='mb-0'>Public :</label>
                            </div>
                            <div className="col-6 text-left pl-0 pr-0">
                                <label className='text-overflow_helper-label-modile-desktop mb-0'>
                                    {props.public}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}